import { MISSION_ENUM_TYPES, MISSION_STATUS_ENUM } from 'shared/constants'
import { getSimpleMissionLink, getAmbassadorLink } from 'Utils/Link'
import { theme } from 'Assets/Styles/theme'
import { format } from 'date-fns'
import {
  isNeedToHideEmployeeLastName,
  hideUserLastName,
} from '../../Utils/User'

const chatSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="15" height="13" viewBox="0 0 15 13" fill="none">
    <path d="M2.45328 0.327148C1.50101 0.327148 0.746094 1.14844 0.746094 2.12917V8.41933C0.746094 8.91025 0.92726 9.3734 1.23386 9.71327C1.54046 10.0531 1.99306 10.2718 2.48715 10.2214L3.01895 10.1673C3.06548 10.1649 3.11104 10.1531 3.15288 10.1326C3.19471 10.1121 3.23196 10.0833 3.26235 10.048C3.29274 10.0127 3.31564 9.97162 3.32968 9.92719C3.34371 9.88277 3.34858 9.83595 3.34399 9.78959C3.3394 9.74323 3.32545 9.69829 3.30297 9.65748C3.2805 9.61667 3.24998 9.58088 3.21325 9.55221C3.17653 9.52355 3.13437 9.5026 3.08933 9.49071C3.04428 9.47882 2.99729 9.47623 2.95121 9.48304L2.41602 9.53713C2.15971 9.56332 1.93191 9.45943 1.74534 9.2526C1.55876 9.04577 1.43371 8.73681 1.43371 8.41933V2.12917C1.43371 1.49313 1.89694 1.01476 2.45328 1.01476H12.6185C13.1748 1.01476 13.638 1.49313 13.638 2.12917V8.41933C13.638 9.0554 13.1748 9.53713 12.6185 9.53713H7.14803C7.10153 9.53495 7.05506 9.54222 7.01146 9.55851C6.96785 9.57481 6.928 9.59978 6.89431 9.63192C6.86063 9.66406 6.83382 9.7027 6.81551 9.7455C6.79719 9.7883 6.78775 9.83438 6.78775 9.88094C6.78775 9.92749 6.79719 9.97357 6.81551 10.0164C6.83382 10.0592 6.86063 10.0978 6.89431 10.13C6.928 10.1621 6.96785 10.1871 7.01146 10.2034C7.05506 10.2197 7.10153 10.2269 7.14803 10.2247H12.6185C13.5707 10.2247 14.3256 9.40008 14.3256 8.41933V2.12917C14.3256 1.14844 13.5707 0.327148 12.6185 0.327148H2.45328Z" fill="#545454"/>
    <path d="M7.01261 9.56396L3.33065 11.1357V9.82478H2.63965V11.6607C2.63978 11.7177 2.65407 11.7737 2.68123 11.8239C2.70839 11.874 2.74757 11.9166 2.79526 11.9478C2.84294 11.979 2.89764 11.9979 2.95443 12.0028C3.01122 12.0077 3.06834 11.9984 3.12064 11.9757L7.28359 10.1974L7.01261 9.56396Z" fill="#545454"/>
    <path d="M3.57109 2.59668C3.47946 2.59668 3.39158 2.63308 3.32678 2.69787C3.26199 2.76267 3.22559 2.85055 3.22559 2.94218C3.22559 3.03381 3.26199 3.12169 3.32678 3.18649C3.39158 3.25128 3.47946 3.28768 3.57109 3.28768H11.4973C11.5889 3.28768 11.6768 3.25128 11.7416 3.18649C11.8064 3.12169 11.8428 3.03381 11.8428 2.94218C11.8428 2.85055 11.8064 2.76267 11.7416 2.69787C11.6768 2.63308 11.5889 2.59668 11.4973 2.59668H3.57109Z" fill="#545454"/>
    <path d="M3.53716 4.93108C3.44599 4.9356 3.36035 4.97617 3.29907 5.04381C3.23779 5.11146 3.20589 5.20066 3.21038 5.29183C3.21487 5.38299 3.25539 5.46864 3.32302 5.52994C3.39065 5.59124 3.47986 5.62316 3.57103 5.6187H11.4972C11.5437 5.62087 11.5902 5.61361 11.6338 5.59731C11.6774 5.58102 11.7173 5.55605 11.7509 5.52391C11.7846 5.49177 11.8114 5.45313 11.8298 5.41033C11.8481 5.36753 11.8575 5.32144 11.8575 5.27489C11.8575 5.22833 11.8481 5.18225 11.8298 5.13945C11.8114 5.09665 11.7846 5.05801 11.7509 5.02587C11.7173 4.99373 11.6774 4.96876 11.6338 4.95246C11.5902 4.93617 11.5437 4.9289 11.4972 4.93108H3.57103C3.55975 4.93053 3.54844 4.93053 3.53716 4.93108H3.53716Z" fill="#545454"/>
    <path d="M3.53716 7.18694C3.44599 7.19145 3.36035 7.23197 3.29907 7.29962C3.23779 7.36727 3.20589 7.45652 3.21038 7.54768C3.21487 7.63885 3.25539 7.7245 3.32302 7.7858C3.39065 7.8471 3.47986 7.87902 3.57103 7.87456H11.4972C11.5437 7.87673 11.5902 7.86947 11.6338 7.85317C11.6774 7.83688 11.7173 7.8119 11.7509 7.77977C11.7846 7.74763 11.8114 7.70898 11.8298 7.66619C11.8481 7.62339 11.8575 7.5773 11.8575 7.53075C11.8575 7.48419 11.8481 7.43811 11.8298 7.39531C11.8114 7.35251 11.7846 7.31387 11.7509 7.28173C11.7173 7.24959 11.6774 7.22462 11.6338 7.20832C11.5902 7.19203 11.5437 7.18476 11.4972 7.18694H3.57103C3.55975 7.18638 3.54844 7.18638 3.53716 7.18694H3.53716Z" fill="#545454"/>
</svg>`

const getChatLink = ambassadorId => {
  return '/dashboard/chat'
}

const WrapperStyles = `
  background: ${theme.colors.white};
  padding-top: 10px;
  min-width: 250px;
  min-height: 150px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
`

const RowStyles = `
  margin-bottom: 6px;
  display: flex;
  align-items: bottom;
  justify-content: space-between;
`

const BANameStyles = `
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  margin-right: 15px;
  color: ${theme.colors.black};
  outline: none;
  text-decoration: none;
`

const ChatStyles = `
  outline: none;
  text-decoration: none;
`

const MissionStatusStyles = color => `
  height: 15px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 13px;
  font-weight: bold;
  font-size: 7px;
  line-height: 15px;
  color: ${theme.colors.white};
  text-transform: capitalize;
  margin-right: 15px;
  border-radius: 7.5px;
  background-color: ${color};
  letter-spacing: 0.35px;
`

const MissionLinkStyles = `
  font-size: 12px;
  line-height: 14px;
  text-decoration: underline;
  color: #4686E7;
  outline: none;
`

const LinkStyles = `
  font-size: 8.5px;
  line-height: 11px;
  text-decoration-line: underline;
  color: #004360;
  outline: none;
`

const LinkModalStyles = `
  display: none;
  position: absolute;
  top: 50%;
  right: 100px;
  transform: translateY(-50%);
  max-width: 250px;
  max-height: 150px;
`

const TextStyles = `
  font-size: 12px;
  line-height: 14px;
  color: ${theme.colors.regentGray};
  margin: 0;
`

const LabelStyles = count => `
  width: calc(100%/${count});
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const getMissionStatusBlock = status => {
  let color = theme.colors.darkAthensGray
  switch (status) {
    case MISSION_STATUS_ENUM.BOOKED:
      color = theme.colors.rebeccaPurple
      break
    case MISSION_STATUS_ENUM.CHECKED_IN:
    case MISSION_STATUS_ENUM.COMPLETED:
      color = '#56D772'
      break
    case MISSION_STATUS_ENUM.UNDER_REVIEW:
      color = theme.colors.darkOrange
  }

  const text = status.replace('_', ' ')

  return `<div style="${MissionStatusStyles(color)}">${text}</div>`
}

export const MarkerModal = ({ mission, cityId }) => {
  const clientName =
    mission.cityPlan &&
    mission.cityPlan.campaign &&
    mission.cityPlan.campaign.client
      ? mission.cityPlan.campaign.client.name
      : ''

  const baName = mission.user
    ? `${mission.user.firstName} ${
        isNeedToHideEmployeeLastName()
          ? hideUserLastName(mission.user.lastName)
          : mission.user.lastName
      }`
    : '-'

  const baBlock = `
    <div style="${RowStyles}">
        <a style="${BANameStyles}"
        href=${mission.user ? getAmbassadorLink(cityId, mission.user.id) : ''}
        target="_blank">${baName}</a>
        
        <div style="${RowStyles}">
            ${getMissionStatusBlock(mission.status)}
            ${
              mission.user
                ? `<a style="${ChatStyles}"
            href="${getChatLink(mission.user && mission.user.id)}"
            target="_blank">${chatSvg}</a>`
                : ''
            }
        </div>
    </div>
  `

  const checkInSelfie =
    !mission.isAnonymize && mission.checkInSelfie
      ? `
  <a style="${LinkStyles}" href=${
          mission.checkInSelfie
        } target="_blank" class='marker-link-with-modal'>
            Checkin Selfie
        </a>
        
        <img class='marker-image-modal-modal' src=${
          mission.checkInSelfie
        } style="${LinkModalStyles}" />
  `
      : ''

  const checkInFlyerCodeImage =
    !mission.isAnonymize && mission.checkInFlyerCodeImage
      ? `
  <a style="${LinkStyles}" href=${
          mission.checkInFlyerCodeImage
        } target="_blank" class='marker-link-with-modal'>
            Code Picture
        </a>
        <img class='marker-image-modal-modal' src=${
          mission.checkInFlyerCodeImage
        } style="${LinkModalStyles}" />
  `
      : ''

  let speedStepsText = ''
  if (mission.type === MISSION_ENUM_TYPES.LETTERBOX) {
    const speed =
      mission.status === MISSION_STATUS_ENUM.CHECKED_IN &&
      mission.lastActivity &&
      mission.lastActivity.speed
        ? `${mission.lastActivity.speed} km/h`
        : ''
    speedStepsText = `Current speed: ${speed}`
  } else if (mission.type === MISSION_ENUM_TYPES.HANDTOHAND) {
    const steps = mission.checkoutStepsWalked
      ? `${mission.checkoutStepsWalked} steps`
      : ''
    speedStepsText = `Steps so far: ${steps}`
  }

  return `
    <style>
      .marker-link-with-modal:hover~.marker-image-modal-modal {
        display: block !important;
      }
    </style>
    <div style="${WrapperStyles}">
      ${baBlock}
      
      <div style="${RowStyles}">
          <a style="${MissionLinkStyles}"
          href=${getSimpleMissionLink(mission.id)} target="_blank">
            ${clientName} - [${mission.id}]
        </a>
        
        ${checkInSelfie}
      </div>
      
      <div style="${RowStyles}">
        <p style="${TextStyles}">
          Start Date:
          ${mission.dateTime ? format(mission.dateTime, 'hh:mm a') : ''}
        </p>
      </div>
        
      <div style="${RowStyles}">
        <p style="${TextStyles}">
          Check-in:
          ${mission.checkInTime ? format(mission.checkInTime, 'hh:mm a') : ''}
        </p>
        
        ${checkInFlyerCodeImage}
      </div>
      
      <div style="${RowStyles}">
        <p style="${TextStyles}">
          Check-out:
          ${mission.checkoutTime ? format(mission.checkoutTime, 'hh:mm a') : ''}
        </p>
      </div>
      
       <div style="${RowStyles}">
        <p style="${TextStyles}">
          Code: ${mission.flyerCode || ''}
        </p>
      </div>
      
      <div style="${RowStyles}">
        <p style="${TextStyles}">
          ${speedStepsText}
        </p>
      </div>
     </div>
  `
}

const getTabHeader = ({ id, user }, index, checked, count) => {
  if (checked) {
    return `<input type="radio" name="tabs" id="tab-${index}"
           checked />
    <label for="tab-${index}" style='${LabelStyles(count)}'>${
      user ? user.firstName : 'Available'
    }</label>`
  }
  return `
    <input type="radio" name="tabs" id="tab-${index}" />
    <label for="tab-${index}" style='${LabelStyles(count)}'>${
    user ? user.firstName : 'Available'
  }</label>
  `
}

const getTabContent = (mission, cityId, index) => {
  return `
  <div class="tab content-${index.toString()}">
    ${MarkerModal({ mission, cityId })}
  </div>
  `
}

export const MarkerModalWithTabs = ({ missions, cityId }) => {
  const modalContents = missions.slice(0, 20).reduce(
    (acc, mission, index) => {
      acc.header += getTabHeader(mission, index, index === 0, missions.length)
      acc.content += getTabContent(mission, cityId, index)

      return acc
    },
    {
      header: '',
      content: '',
    },
  )

  const result = `
<style>
  .live-map-marker-tab {
    display: flex;
    flex-wrap: wrap;
    width: 350px;
  }
  input { display: none;}               
  input + label { 
    cursor: pointer;
    display: inline-flex;
    justify-content: center;
    border: 0.5px solid rgba(0, 0, 0, 0.06);
    background: #fff;
    padding: 6px 14px;
    color: #F0F0F0;
  }
  input ~ .tab { display: none; width: 100%; }        
  input:checked + label {    
    background: rgba(196, 196, 196, 0.2);
    border-bottom: 1px solid transparent;
    color: #545454;
  }
  #tab-0:checked ~ .tab.content-0,
  #tab-1:checked ~ .tab.content-1,
  #tab-2:checked ~ .tab.content-2,
  #tab-3:checked ~ .tab.content-3,
  #tab-4:checked ~ .tab.content-4,
  #tab-5:checked ~ .tab.content-5,
  #tab-6:checked ~ .tab.content-6,
  #tab-7:checked ~ .tab.content-7,
  #tab-8:checked ~ .tab.content-8,
  #tab-9:checked ~ .tab.content-9,
  #tab-10:checked ~ .tab.content-10,
  #tab-11:checked ~ .tab.content-11,
  #tab-12:checked ~ .tab.content-12,
  #tab-13:checked ~ .tab.content-13,
  #tab-14:checked ~ .tab.content-14,
  #tab-15:checked ~ .tab.content-15,
  #tab-16:checked ~ .tab.content-16,
  #tab-17:checked ~ .tab.content-17,
  #tab-18:checked ~ .tab.content-18,
  #tab-19:checked ~ .tab.content-19
   { display: block; }
</style>
  <div class='live-map-marker-tab'>
      ${modalContents.header}
      ${modalContents.content}
  </div>
  `

  return result
}
